import { jsonApiVuex } from '@common/store/json-api-vuex';

export const standardEventType = jsonApiVuex('normalized-datalayer/standard-event-type', {}, {});
